/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { StakingReward, StakingRewardInterface } from "../StakingReward";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract Staking",
        name: "_staking",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    name: "StakingRewardClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "contributor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "contribution",
        type: "uint256",
      },
    ],
    name: "StakingRewardContributed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addPauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_rewardRequest",
        type: "bytes",
      },
      {
        internalType: "bytes[]",
        name: "_sigs",
        type: "bytes[]",
      },
    ],
    name: "claimReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "claimedRewardAmounts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "contributeToRewardPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "drainToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isPauser",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pausers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renouncePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "staking",
    outputs: [
      {
        internalType: "contract Staking",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type StakingRewardConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: StakingRewardConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class StakingReward__factory extends ContractFactory {
  constructor(...args: StakingRewardConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "StakingReward";
  }

  deploy(_staking: string, overrides?: Overrides & { from?: string | Promise<string> }): Promise<StakingReward> {
    return super.deploy(_staking, overrides || {}) as Promise<StakingReward>;
  }
  getDeployTransaction(
    _staking: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_staking, overrides || {});
  }
  attach(address: string): StakingReward {
    return super.attach(address) as StakingReward;
  }
  connect(signer: Signer): StakingReward__factory {
    return super.connect(signer) as StakingReward__factory;
  }
  static readonly contractName: "StakingReward";
  public readonly contractName: "StakingReward";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingRewardInterface {
    return new utils.Interface(_abi) as StakingRewardInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): StakingReward {
    return new Contract(address, _abi, signerOrProvider) as StakingReward;
  }
}
